"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BaseTheme = _interopRequireDefault(require("../../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Error = () => /*#__PURE__*/_react.default.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: _BaseTheme.default.colors.red,
  d: "M16,26 C21.5228475,26 26,21.5228475 26,16 C26,10.4771525 21.5228475,6 16,6 C10.4771525,6 6,10.4771525 6,16 C6,21.5228475 10.4771525,26 16,26 Z M20.2426407,11.7573593 C20.4769553,11.9916739 20.4769553,12.3715729 20.2426407,12.6058875 L16.8485281,16 L20.2426407,19.3941125 C20.4769553,19.6284271 20.4769553,20.0083261 20.2426407,20.2426407 C20.0083261,20.4769553 19.6284271,20.4769553 19.3941125,20.2426407 L16,16.8485281 L12.6058875,20.2426407 C12.3715729,20.4769553 11.9916739,20.4769553 11.7573593,20.2426407 C11.5230447,20.0083261 11.5230447,19.6284271 11.7573593,19.3941125 L15.1514719,16 L11.7573593,12.6058875 C11.5230447,12.3715729 11.5230447,11.9916739 11.7573593,11.7573593 C11.9916739,11.5230447 12.3715729,11.5230447 12.6058875,11.7573593 L16,15.1514719 L19.3941125,11.7573593 C19.6284271,11.5230447 20.0083261,11.5230447 20.2426407,11.7573593 Z"
}));

var _default = Error;
exports.default = _default;